import type {OrigenDeFecha} from '@cnc/contracts';
import {tr} from '../i18n/idioma';
import {fecha} from '../utilidades/formato';

// Una fecha esperada con su origen: "↻" si se calculo con el seguimiento
// (zarpe o ETA a Mundra), asi se mueve sola cuando el seguimiento cambia
// (Daniel, 8/10/2026).
export function FechaSegun({valor, segun, regla}: {valor: string | null; segun: OrigenDeFecha | null; regla?: string}) {
  if (!valor) return <>—</>;
  if (segun !== 'seguimiento') return <>{fecha(valor)}</>;
  return (
    <span
      className="whitespace-nowrap"
      title={
        regla ??
        tr(
          'Calculada con el seguimiento: cambia sola si cambian el zarpe o la ETA.',
          'Calculated from the tracking: it changes by itself if the departure or the ETA change.',
        )
      }
    >
      {fecha(valor)} <span className="text-xs text-verde">↻</span>
    </span>
  );
}

export const REGLA_DESEMBOLSO = () =>
  tr(
    'Del seguimiento: BLQ le paga a la empresa del grupo el día del zarpe.',
    'From the tracking: BLQ pays the group company on the departure day.',
  );
export const REGLA_PAGO_AL_FINANCIADOR = () =>
  tr(
    'Del seguimiento: se le paga a BLQ en días hábiles antes de la llegada a Mundra (Hindustan 5 días; en Mineros, Nimbus 3 días). No cuentan festivos de Suiza, Dubái e India.',
    'From the tracking: BLQ is paid in business days before arrival in Mundra (Hindustan 5 days; for Mineros, Nimbus 3 days). Swiss, Dubai and Indian holidays do not count.',
  );
